














































































































































































































































































































































































































































import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { FinDocViewModel } from "./models";
import { ListModel } from "@/shared/models/listModel";
import { BusinessUnit } from "@/shared/models/businessUnit";
import { CardType } from "@/shared/models/cardType";
import { CashRegisterModel } from "@/shared/models/cashRegister";
import {
  FinancialDocumentStatusEnum,
  FinancialDocumentTypesEnum,
  PaymentMeansEnum,
} from "@/shared/models/enums.type";
import { PaymentMean } from "@/shared/models/paymentMean";
import { FinancialSettingsType } from "@/store/modules/financial";
import { VFinancialDocument } from "@/shared/models/VFinancialDocument";
import DateField from "@/components/misc/DateField.vue";
import FinancialDocumentPaymentMeansAdditionalDetailsModal from "./../FinancialDocumentPaymentMeansAdditionalDetailsModal.vue";
import CreditCardInfoModal from "@/components/credit-card/CreditCardInfoModal.vue";
import { getPriceSummary } from "./functions";
import * as _ from "lodash";

interface PreviousDocument {
  id: number;
  documentNumber: string;
  documentIdentifier: string;
  documentInternalIdentifier: string;
  issueDate: string;
  typeId: number;
}

@Component({
  components: {
    DateField,
    FinancialDocumentPaymentMeansAdditionalDetailsModal,
    CreditCardInfoModal,
  },
})
export default class BasicInfo extends Vue {
  @PropSync("finDocModel") finDocModelInternal!: FinDocViewModel;

  @Prop() automaticallyCancelRelatedAdvanceInvoices?: boolean;

  paymentMeansEnum = PaymentMeansEnum;
  previousDocuments = [] as PreviousDocument[];

  // helper properties
  get basicInfo() {
    return this.finDocModelInternal.basicInfo;
  }

  get documentTypeId() {
    if (
      this.finDocModelInternal.documentTypeId ===
      FinancialDocumentTypesEnum.Storno
    )
      return this.basicInfo.referenceDocumentTypeId;
    return this.finDocModelInternal.documentTypeId;
  }

  get isLocked() {
    return (
      this.finDocModelInternal.documentStatusId !==
      FinancialDocumentStatusEnum.UIzradi
    );
  }

  get isCancellation() {
    return (
      this.finDocModelInternal.documentTypeId ===
      FinancialDocumentTypesEnum.Storno
    );
  }

  get paymentMeansCols() {
    let cols = 6;
    if (
      this.basicInfo.paymentMeansId === PaymentMeansEnum.Ostalo ||
      this.paymentMeanBaseId === PaymentMeansEnum.Ostalo
    ) {
      cols -= 2;
    }
    if (
      this.finDocModelInternal.reservationId &&
      this.basicInfo.hasSavedCreditCard
    )
      cols--;
    return cols;
  }

  get totalToPay() {
    const summary = getPriceSummary(this.finDocModelInternal);
    return this.automaticallyCancelRelatedAdvanceInvoices
      ? summary.toPayWithoutAdvance
      : summary.toPay;
  }

  get showCardTypeSelection() {
    const paymentMeansId = this.basicInfo.paymentMeansId ?? 0;

    if (
      paymentMeansId === PaymentMeansEnum.KreditnaKartica ||
      paymentMeansId === PaymentMeansEnum.BankovnaKartica ||
      this.paymentMeanBaseId === PaymentMeansEnum.KreditnaKartica ||
      this.paymentMeanBaseId === PaymentMeansEnum.BankovnaKartica
    ) {
      return true;
    } else {
      this.basicInfo.cardTypeId = null;
      return false;
    }
  }

  get paymentMeanBaseId() {
    return this.paymentMeans?.find(
      (e) => e.id === this.basicInfo.paymentMeansId
    )?.paymentMeanBaseId;
  }

  get deliveryDateMax() {
    return this.documentTypeId === FinancialDocumentTypesEnum.Racun ||
      this.documentTypeId === FinancialDocumentTypesEnum.RacunZaProviziju
      ? this.basicInfo.issueDate
      : undefined;
  }

  allowBusinessUnitEditForCancellation = false;
  @Watch("basicInfo.businessUnitId", { immediate: true })
  businessUnitChangedImmediate(fresh: number | null, old: number | null) {
    if (!this.isLocked && this.basicInfo.businessUnitId) {
      const bu = this.allBusinessUnits?.find((x) => x.id === fresh);
      if (!bu || !bu.status) {
        this.basicInfo.businessUnitId = null;
        this.basicInfo.cashRegisterId = null;
        this.allowBusinessUnitEditForCancellation = true;
      }
    }

    if (fresh && old && fresh !== old && !this.isLocked){
      this.basicInfo.cashRegisterId = null;
    }
  }

  // functions
  get servicePeriod() {
    const res = [
      this.basicInfo.servicePeriodFromDate
        ? this.basicInfo.servicePeriodFromDate.substring(0, 10) ?? ""
        : "",
      this.basicInfo.servicePeriodToDate
        ? this.basicInfo.servicePeriodToDate.substring(0, 10) ?? ""
        : "",
    ].filter((x) => !!x) as string[];
    return res;
  }
  set servicePeriod(val: string[]) {
    if (val && _.isArray(val)) {
      this.basicInfo.servicePeriodFromDate = val.length > 0 ? val[0] : null;
      this.basicInfo.servicePeriodToDate = val.length > 1 ? val[1] : null;
    }
  }

  paymentMeansChanged() {
    if (
      (this.basicInfo.paymentMeansId === PaymentMeansEnum.Ostalo ||
        this.paymentMeanBaseId === PaymentMeansEnum.Ostalo) &&
      (!this.basicInfo.paymentMeansAdditionalDetails ||
        this.basicInfo.paymentMeansAdditionalDetails.length === 0)
    ) {
      this.basicInfo.paymentMeansAdditionalDetails = [
        {
          id: 0,
          paymentMeansId: null,
          cardTypeId: null,
          amount: null,
          currencyId: this.finDocModelInternal.formalCurrencyId ?? null,
        },
      ];
    }
  }

  referenceDocumentChanged() {
    const refDoc = this.previousDocuments.find(
      (e) => e.id == this.basicInfo.referenceDocumentId
    );
    this.basicInfo.referenceDocumentTypeId = refDoc?.typeId ?? null;
  }

  @Watch("finDocModelInternal.reservationId", { immediate: true })
  modelChanged(fresh?: number) {
    this.previousDocuments = [];
    if (!fresh) return;

    let queryParams = {};
    if (this.isCancellation) {
      queryParams = {
        $top: 1000,
        statusIds: [
          FinancialDocumentStatusEnum.Zakljucen,
          FinancialDocumentStatusEnum.Placen,
        ].join(","),
        isCancellation: true,
        reservationId: fresh,
      };
    } else {
      queryParams = {
        $top: 1000,
        statusIds: [
          FinancialDocumentStatusEnum.Zakljucen,
          FinancialDocumentStatusEnum.Placen,
          FinancialDocumentStatusEnum.Storniran,
        ].join(","),
        reservationId: fresh,
      };
    }

    this.axios
      .get<ListModel<VFinancialDocument>>("/financialDocuments", {
        params: queryParams,
      })
      .then((x) => {
        this.previousDocuments = x.data.result.map((d) => ({
          id: d.financialDocumentId,
          documentNumber: d.documentNumberComplete ?? "",
          documentIdentifier: d.documentIdentifier ?? "",
          documentInternalIdentifier: d.documentInternalIdentifier ?? "",
          issueDate: d.issueDate,
          typeId: d.typeId,
        }));
      });
  }

  // validation
  get rules() {
    return {
      required: (value: any) =>
        !!value || this.$t("Validation.Required").toString(),
      // prettier-ignore
      dueDateCannotBeLessThanIssueDate: (value: any) =>
        ( 
          value &&
          this.basicInfo &&
          this.basicInfo.dueDate &&
          this.basicInfo.issueDate &&
          !(this.basicInfo.dueDate.substr(0, 10) < this.basicInfo.issueDate.substr(0, 10))
        ) ||
        this.$t("Validation.FinancialDocuments.DueDateCannotBeBeforeIssueDate"),
      // prettier-ignore
      deliveryDateCannotBeGreaterThanIssueDateIfInvoice: (value: any) =>
        ( 
          value &&
          this.basicInfo &&
          this.basicInfo.deliveryDate &&
          this.basicInfo.issueDate &&
          !(this.basicInfo.issueDate.substr(0, 10) < this.basicInfo.deliveryDate.substr(0, 10))
        ) || (
          (this.documentTypeId !== FinancialDocumentTypesEnum.Racun && this.documentTypeId !== FinancialDocumentTypesEnum.RacunZaProviziju) // anly applies to invoices and commission invoices
        ) ||
        this.$t("Validation.FinancialDocuments.DeliveryDateCannotBeAfterIssueDate"),
    };
  }

  // settings
  get servicePeriodTextResource() {
    if (!this.storedSettings?.showServicePeriod) return "";

    return this.documentTypeId === FinancialDocumentTypesEnum.RacunZaPredujam
      ? "VFinancialDocument.Prepayment.servicePeriod"
      : "VFinancialDocument.servicePeriod";
  }

  get deliveryDateTextResource() {
    return this.documentTypeId === FinancialDocumentTypesEnum.RacunZaPredujam
      ? "VFinancialDocument.Prepayment.deliveryDate"
      : "VFinancialDocument.deliveryDate";
  }

  get enableServicePeriodEditing() {
    return this.storedSettings?.enableServicePeriodEditing ?? false;
  }

  get fiscalizeOffers() {
    return this.storedSettings?.fiscalizeOffers ?? false;
  }

  get isFiscalNumberMain() {
    return this.storedSettings?.setFiscalNumberAsMain ?? false;
  }

  get sortedBusinessUnits() {
    //sorting availableBusinessUnits directly causes 'infinite loop error' when entering 'Storno' from 'FinancialDocumentModalForm'
    //possibly because of nested 'FinancialDocumentModalForm' and 'BasicInfo'
    //cloning to a new array before sorting solves this issue
    const cloneAvailableBusinessUnits = this.isLocked
      ? _.cloneDeep(this.allBusinessUnits)
      : _.cloneDeep(this.availableBusinessUnits);

    return (
      cloneAvailableBusinessUnits?.sort((a, b) =>
        !a.ownerCustomerId && b.ownerCustomerId ? -1 : 1
      ) ?? []
    );
  }

  get cashRegistersForBusinessUnit() {
    return this.isLocked
      ? this.allCashRegisters?.filter(
          (x) => x.id === this.basicInfo?.cashRegisterId
        ) ?? []
      : this.allCashRegisters?.filter(
          (x) => x.status && x.businessUnitId === this.basicInfo?.businessUnitId
        ) ?? [];
  }

  // getters and setup
  @Getter("financial/settings") storedSettings?: FinancialSettingsType;
  @Getter("appParams/cashRegisterFeatureFlag")
  cashRegisterFeature?: boolean;

  @Getter("businessUnit/availableBusinessUnits")
  availableBusinessUnits?: BusinessUnit[];
  @Getter("businessUnit/allBusinessUnits") allBusinessUnits?: BusinessUnit[];
  @Getter("cashRegister/allCashRegisters")
  allCashRegisters?: CashRegisterModel[];
  @Action("cashRegister/refreshCashRegisters")
  refreshCashRegisters?: () => void;

  @Action("codebooks/refreshPaymentMeans")
  refreshPaymentMeans?: () => Promise<void>;
  @Getter("codebooks/paymentMeans") paymentMeans?: PaymentMean[];
  @Action("codebooks/refreshCardTypes") refreshCardTypes?: () => Promise<void>;
  @Getter("codebooks/cardTypes") cardTypes?: CardType[];

  @Getter("appParams/isCardTypeRequiredForCardPaymentMeans")
  isCardTypeRequiredForCardPaymentMeans?: boolean;

  async created() {
    const promises = [];

    if ((this.paymentMeans?.length ?? 0) === 0 && this.refreshPaymentMeans) {
      promises.push(this.refreshPaymentMeans());
    }

    if ((this.cardTypes?.length ?? 0) === 0 && this.refreshCardTypes) {
      promises.push(this.refreshCardTypes());
    }

    if (
      (this.allCashRegisters?.length ?? 0) === 0 &&
      this.refreshCashRegisters
    ) {
      promises.push(this.refreshCashRegisters());
    }

    await Promise.all(promises);
  }
}
